/** Checkout URL ve adım sabitleri — sunucu bileşenlerinden güvenle import edilebilir (`'use client'` değil). */

export enum CheckoutStepType {
  RECEIVER_INFO = 1,
  BILL_INFO = 2,
  PAYMENT_INFO = 3,
}

export enum ReceiverInfoStep {
  RECEIVER_INFO = 1,
  EXTRA_PRODUCT = 2,
  CARD_MESSAGES = 3,
}

export enum CheckoutPage {
  CHECKOUT_BASE_PAGE = 'satin-al',
  CHECKOUT_RECEIVER_PAGE = 'satin-al-alici-bilgileri',
  CHECKOUT_EXTRA_PAGE = 'satin-al-ekstra-urunler',
  CHECKOUT_PHOTO_PRINT_PAGE = 'satin-al-fotograf-baskisi',
  CHECKOUT_MESSAGE_PAGE = 'satin-al-mesaj-bilgileri',
  CHECKOUT_INVOICE_PAGE = 'satin-al-fatura-bilgileri',
  CHECKOUT_PAYMENT_PAGE = 'satin-al-odeme',
}

export interface CheckoutStep {
  type: CheckoutStepType;
  title: string;
  url?: string;
  stepUrls?: { [key: string]: string };
  prevUrl?: string;
}
